<template>
  <v-container fluid>
    <PageTitle>
      <div>
        Clean Email Lists
      </div>
      <div>
        <v-btn href="https://help.mobilelocker.com/article/257-how-to-clean-an-email-list"
               target="_blank"
               icon
               color="primary">
          <v-icon>
            fas fa-fw fa-question-circle
          </v-icon>
        </v-btn>
      </div>

      <template v-if="emailCreditInfo"
                v-slot:buttons>

        <div class="me-4">
          <v-icon left>
            fal fa-fw fa-coins
          </v-icon>
          {{ emailCreditInfo.available_credits | number }} {{ emailCreditInfo.available_credits | pluralize('Credit', false) }}
        </div>

        <v-dialog v-model="creditsDialog"
                  width="600px">
          <template v-slot:activator="{on, attrs}">
            <v-btn color="primary"
                   :disabled="canVerifyEmails === false"
                   v-bind="attrs"
                   v-on="on">
              Buy Credits
            </v-btn>
          </template>

          <template v-slot:default>
            <PurchaseCreditsForm @updated="handlePurchaseCompleted">
            </PurchaseCreditsForm>
          </template>
        </v-dialog>
      </template>
    </PageTitle>

    <template v-if="team.email_verification_enabled === false">
      <ExplainEmailVerificationCard @updated="fetchemailCreditInfo">
      </ExplainEmailVerificationCard>
    </template>
    <template v-else-if="canVerifyEmails === false">
      <v-alert type="info"
               tile>
        You do not have the necessary permission to clean email lists. Contact your Mobile Locker administrator.
      </v-alert>
    </template>

    <template v-else>
      <v-form v-if="hasCreditsAvailable"
              @submit.prevent="upload"
              class="mb-6"
              :disabled="form.busy">
        <v-card>
          <v-card-title>
            Clean an Email List
          </v-card-title>
          <v-card-text>

            <ol class="mb-4">
              <li>
                Upload your list in CSV format (<a href="https://help.mobilelocker.com/article/255-how-to-convert-an-excel-file-to-csv" target="_blank">Learn how to convert Excel to CSV</a>).
              </li>
              <li>
                Emails must be in the first column (You may include unlimited columns of other data).
              </li>
              <li>
                When finished uploading, the list will be cleaned.
              </li>
            </ol>

            <v-file-input v-model="form.file"
                          :disabled="form.busy || csvBusy"
                          label="Email List CSV File"
                          placeholder="Click here to upload your CSV file."
                          prepend-icon=""
                          :truncate-length="100"
                          persistent-placeholder
                          accept=".csv"
                          @change="parseFileUpload"
                          outlined
                          required
                          :error-messages="form.errors.get('file')">
            </v-file-input>

            <v-expansion-panels v-if="form.file"
                                tile>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Advanced Settings
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-switch v-model="form.auto_parse"
                            :disabled="form.run_sample"
                            label="Parse the job immediately?"
                            hide-details>
                  </v-switch>
                  <v-switch v-model="form.auto_start"
                            :disabled="form.run_sample"
                            label="Start the job immediately after being parsed?"
                            hide-details>
                  </v-switch>
                  <v-switch v-model="form.run_sample"
                            label="Run a free analysis on this list?"
                            hide-details
                            @change="changeRunSample">
                  </v-switch>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-card-text>

          <v-progress-linear v-if="1===2 && csvBusy"
                             indeterminate
                             color="primary"
                             height="10">
          </v-progress-linear>

          <template v-if="hasValidEmails && csvBusy === false">

            <div ref="hotTable"></div>

            <ErrorAlert v-if="error"
                        :error="error">
            </ErrorAlert>
            <v-alert v-else-if="form.run_sample"
                     type="info"
                     tile
                     class="mb-0">
              Running a free analysis will determine the overall health of your list. It will not consume any credits.
            </v-alert>
            <v-alert v-else-if="hasEnoughCreditsToCleanList"
                     type="success"
                     tile
                     class="mb-0">
              Cleaning this list will consume {{ this.validEmailCount | number }} {{ this.validEmailCount | pluralize('credit', false) }}.
            </v-alert>
            <v-alert v-else-if="hasEnoughCreditsToCleanList === false"
                     type="error"
                     tile
                     class="mb-0">
              You need to buy at least {{ creditsNeeded }} more {{ creditsNeeded | pluralize('credit', false) }} to clean this list. <a href="#" @click.prevent="creditsDialog = true" class="white--text">Buy more credits</a>.
            </v-alert>

            <v-card-actions v-if="hasEnoughCreditsToCleanList"
                            class="px-4">
              <v-btn type="submit"
                     color="primary"
                     :disabled="form.busy">
                Upload List
              </v-btn>
            </v-card-actions>

          </template>
        </v-card>
      </v-form>

      <v-alert v-else
               type="info">
        You need to <a href="#" @click.prevent="creditsDialog = true" class="white--text">buy credits</a> before you can clean an email list.
      </v-alert>

      <div class="EmailListCards">
        <EmailListCard v-for="list in lists"
                       :key="list.id"
                       :list="list"
                       :credit-info="emailCreditInfo"
                       @updated="fetchData"
                       class="mb-4">
        </EmailListCard>
      </div>
    </template>

  </v-container>
</template>
<script>
import {Form} from 'vform';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.min.css';
import handsonTableService from '../../../../handsontable';
import PageTitle from '../../components/PageTitle.vue';
import neverbounceService from '../../services/neverbounceService';
import {orderBy} from 'lodash';
import EmailListCard from './components/EmailListCard.vue';
import PurchaseCreditsForm from './components/PurchaseCreditsForm.vue';
import echo from '../../plugins/echo';
import Papa from 'papaparse';
import {mapGetters} from 'vuex';
import validationService from '../../services/validationService';
import ExplainEmailVerificationCard from './components/ExplainEmailVerificationCard.vue';
import ErrorAlert from '../../components/ErrorAlert.vue';

//registerAllModules();

export default {
  components: {ErrorAlert, ExplainEmailVerificationCard, EmailListCard, PageTitle, PurchaseCreditsForm},
  data() {
    return {
      busy: false,
      creditsDialog: false,
      error: null,
      form: new Form({
        file: null,
        auto_parse: true,
        auto_start: true,
        run_sample: false,
      }),
      lists: [],
      hotTable: null,
      csvRows: [],
      csvColumnHeaders: [],
      csvFirstKey: null,
      csvBusy: false,
      validEmailCount: 0,
    }
  },
  computed: {
    ...mapGetters([
      'canVerifyEmails',
      'emailCreditInfo', // MLD-6180
      'team',
      'user',
    ]),
    hasValidEmails() {
      return this.validEmailCount > 0;
    },
    hasCreditsAvailable() {
      if (this.emailCreditInfo) {
        return this.emailCreditInfo.available_credits > 0;
      }
      return false;
    },
    hasEnoughCreditsToCleanList() {
      if (this.form.file && this.emailCreditInfo) {
        if (this.validEmailCount <= this.emailCreditInfo.available_credits) {
          return true;
        }
      }
      return false;
    },
    creditsNeeded() {
      if (this.emailCreditInfo) {
        return Math.abs(this.validEmailCount - this.emailCreditInfo.available_credits);
      }
      return null;
    },
  },
  created() {
    if (this.$route.query.buy_credits) {
      this.creditsDialog = true;
    }
    this.initEcho();
    this.fetchData();
  },
  methods: {
    initEcho() {
      echo.private(this.user.channel)
        .listen('NeverBounce.EmailListParsingStarted', e => {
          console.log('Started', e)
          this.fetchData();
        })
        .listen('NeverBounce.EmailListParsingFinished', e => {
          console.log('Finished', e)
          this.fetchData();
        })
        .listen('NeverBounce.EmailListVerificationStarted', e => {
          console.log('Started', e)
          this.fetchData();
        })
        .listen('NeverBounce.EmailListVerificationRunning', e => {
          console.log('Running', e)
          this.fetchData();
        })
        .listen('NeverBounce.EmailListVerificationFinished', e => {
          console.log('Finished', e)
          this.fetchData();
        })
    },
    async countValidEmails(key, rows) {
      //console.log('Counting valid emails: STARTED');
      let validEmails = new Set();
      rows.forEach(row => {
        const email = row[key].trim().toLowerCase();
        if (validationService.isEmailValid(email)) {
          validEmails.add(email);
        }
      })
      //console.log('Counting valid emails: FINISHED', validEmails.size);
      return validEmails.size;
    },
    fetchData() {
      this.fetchEmailCreditInfo();
      this.fetchLists();
    },
    async fetchEmailCreditInfo() {
      await this.$store.dispatch('fetchEmailCreditInfo');
    },
    async fetchLists() {
      return neverbounceService.getLists()
        .then(lists => {
          this.lists = orderBy(lists, ['created_at'], ['desc']);
        })
    },
    changeRunSample() {
      if (this.form.run_sample) {
        this.form.auto_parse = true;
        this.form.auto_start = true;
      }
    },
    parseFileUpload() {
      this.csvRows = [];
      this.csvColumnHeaders = [];
      this.csvFirstKey = null;
      this.validEmailCount = 0;
      this.error = null;
      if (this.form.file) {
        this.csvBusy = true;

        const reader = new FileReader();
        reader.onload = (e) => {
          const csvFile = e.target.result;
          // @see https://www.papaparse.com/docs#config
          const config = {
            complete: async (results) => {
              //console.log('Parsing complete');
              this.csvRows = results.data;
              if (results.data.length > 0) {
                this.csvColumnHeaders = Object.keys(results.data[0]);
                this.csvFirstKey = this.csvColumnHeaders[0];
                this.validEmailCount = await this.countValidEmails(this.csvFirstKey, results.data);
                this.csvBusy = false;

                this.$nextTick(() => {
                  const config = {
                    colHeaders: this.csvColumnHeaders,
                    rowHeaders: true,
                    data: results.data,
                    height: '160px',
                    readOnly: true,
                    renderAllRows: false,
                    minSpareRows: 0,
                    minSpareCols: 0,
                    licenseKey: handsonTableService.LICENSE_KEY
                  }
                  this.hotTable = new Handsontable(this.$refs.hotTable, config)
                });
              } else {
                this.csvColumnHeaders = [];
                this.csvFirstKey = null;
                this.validEmailCount = 0;
                this.csvBusy = false;
              }
            },
            error: (err, file, inputElem, reason) => {
              //console.log('Parsing error', err);
              this.error = err;
              this.csvBusy = false;
            },
            header: true, // Assuming the first row is a header
            fastMode: false,
            worker: true,
          }

          try {
            //console.log('Parsing starting');
            Papa.parse(csvFile, config);
            //console.log('Parsing started');
          } catch (error) {
            this.$toast.error('There was a problem parsing the CSV file.');
            this.error = error;
          }
        };

        reader.readAsText(this.form.file);
      }
    },
    resetUploadForm() {
      this.form.reset();
      this.csvRows = [];
      this.csvColumnHeaders = [];
      this.csvFirstKey = null;
      this.validEmailCount = 0;
    },
    async upload() {
      this.error = null;
      try {
        await this.form.post(`/api/neverbounce/email-lists`, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.resetUploadForm();
        this.fetchData();
      } catch (error) {
        this.error = error;
      }
    },
    handlePurchaseCompleted() {
      this.creditsDialog = false;
      this.fetchemailCreditInfo();
    },
  }
}
</script>
